import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'wilson-delete-renderer',
  template: `
    <button nz-button nzType="text" (click)="onDelete()">
      <fa-icon [icon]="faTrash"></fa-icon>
    </button>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NzButtonModule, NzIconModule, FontAwesomeModule],
})
export class DeleteRendererComponent {
  @Input() index!: number;
  @Output() delete = new EventEmitter<void>();

  faTrash = faTrash;

  onDelete(): void {
    this.delete.emit();
  }
}
